import { render, staticRenderFns } from "./ItineraryWelcomeModal.vue?vue&type=template&id=a60bf74e&"
import script from "./ItineraryWelcomeModal.vue?vue&type=script&lang=js&"
export * from "./ItineraryWelcomeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports